module.exports = __webpack_public_path__ + "images/graphic-header@2x_fea711ac1b775c3e249c06c908ab6bcd.png";